import {produce} from 'immer';

import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';
import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';

import {isStaticTaskSchemaNodeData, StaticFlowchartNodeData} from '../processFlowchartConfigEditorNodeTypes';
import {FlowchartConfigWithMetadata} from '../redux/flowchartConfigAutosaveManagerCallbacks';
import {LoadedFlowchartData, StatusCountsByNodeConfigId} from './executionFlowchartData';
import {ExecutionEditorMode} from './ExecutionFlowchartPaneTypes';

function applyStatusCountsToNodes(
  nodesStaticData: Array<StaticFlowchartNodeData>,
  statusCountsByNodeConfigId: StatusCountsByNodeConfigId
): Array<StaticFlowchartNodeData> {
  if (Object.keys(statusCountsByNodeConfigId).length === 0) {
    return nodesStaticData;
  }
  return produce(nodesStaticData, (draft) => {
    for (const node of draft) {
      if (!isStaticTaskSchemaNodeData(node)) {
        continue;
      }
      const counts = statusCountsByNodeConfigId[node.id];
      if (counts != null) {
        node.statusCounts = counts;
      }
    }
  });
}

export function createInitialExecutionDraftState(
  data: LoadedFlowchartData,
  editorMode: ExecutionEditorMode,
  executionEditorConfigurator: ProcessFlowchartEditorConfigurator,
  statusCountsByNodeConfigId?: StatusCountsByNodeConfigId
): FlowchartConfigWithMetadata {
  const nodesStaticData =
    statusCountsByNodeConfigId != null
      ? applyStatusCountsToNodes(data.initialStaticFlowchart.nodesStaticData, statusCountsByNodeConfigId)
      : data.initialStaticFlowchart.nodesStaticData;
  return {
    staticFlowchart: {
      ...data.initialStaticFlowchart,
      nodesStaticData,
    },
    metadata: {
      transitions: data.initialTransitions,
      rootTaskSchema: data.rootTaskSchema,
      interactionState: {
        selectedNodeIds: new Set<string>(),
        selectedRowIds: new Set<string>(),
        selectedEdgeIds: new Set<string>(),
        edgeLabelsByEdgeId: {},
      },
      currentVersionId: null,
      didInitialFlowchartHaveChainedRouters: data.hasChainedRouters,
      flowchartTypeName: executionEditorConfigurator.flowchartTypeName,
      options: {
        isFlowchartModifiableOnCreation: editorMode === FlowchartEditorMode.ACM_EDITOR,
        isFlowchartModifiableAfterCreation: editorMode === FlowchartEditorMode.PCM_EDITOR,
      },
    },
  };
}
